<template>
  <FreeModal
    with-blackout
    container-style="width: min-content"
    :name="modalName"
  >
    <template #header>
      <h3 class="text-text-neutral-primary text-center text-lg font-semibold">
        {{ $t('passengersData.addNewData.title') }}
      </h3>
    </template>
    <template #default="{ hide }">
      <div class="mt-1">
        <p class="text-text-neutral-tertiary text-center text-sm font-medium">
          {{ $t('passengersData.addNewData.description') }}
        </p>
        <div class="mt-6 flex flex-col space-y-3">
          <FreeButton
            type="button"
            class="green-main-button"
            @click="onAgree(hide)"
          >
            {{ $t('passengersData.addNewData.agree') }}
          </FreeButton>
          <FreeButton type="button" class="gray-button min-w-max" @click="hide">
            {{ $t('passengersData.addNewData.chooseAnotherPassenger') }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { FreeButton, FreeModal } from 'freedom-shared';

  defineProps<{
    modalName: string;
  }>();

  const emit = defineEmits<{
    onAgree: [];
  }>();

  const onAgree = (hide: () => void) => {
    emit('onAgree');
    hide();
  };
</script>
